import { message, Modal, Table, Tag } from 'antd';
import DraggableModal from '@/common/ant-components/DraggableModal';
import { useState } from 'react';
import { AntButton } from '@/common/ant-components/AntButton';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import { encryptData } from '@/components/reusable/crypto/Cipher';
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { addFinancialData } from '@/redux/slices/FinancialYearDataSlice';

export const ModalFiscalYear = ({
  fiscalYearOpen,
  setFiscalYearOpen,
  fiscalYearData = [],
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [record, setRecord] = useState({});

  const userData = decryptData(localStorage.getItem('userData'));

  const { confirm } = Modal;

  return (
    <>
      <DraggableModal
        open={fiscalYearOpen}
        setOpen={() => {}}
        maskClosable={false}
        width={'80%'}
        onCancel={() => {
          setFiscalYearOpen(false);
        }}
        title={
          <div className="tw-flex tw-justify-center">
            {'Financial Year List'}
          </div>
        }
        footer={null}
      >
        <div style={{ padding: '4px 15px' }}>
          <Table
            bordered
            rowClassName={() => 'tw-cursor-pointer'}
            dataSource={fiscalYearData?.filter(
              (item) => item?.financialId !== userData?.financialId,
            )}
            columns={columns}
            pagination={false}
            onRow={(record) => ({
              onClick: () => {
                setRecord(record);
                setConfirmVisible(true);
              },
            })}
          />
        </div>
      </DraggableModal>

      <DraggableModal
        open={confirmVisible}
        setOpen={() => {}}
        maskClosable={false}
        width="35%"
        onCancel={() => setConfirmVisible(false)}
        title={
          <div className="tw-flex tw-items-center tw-gap-2">
            <ExclamationCircleFilled
              style={{ color: '#faad14', fontSize: 20 }}
            />
            <span>
              Are you sure you want to switch to fiscal year{' '}
              <span
                style={{ color: 'rgba(255, 77, 79, 0.85)', paddingLeft: 3 }}
              >
                {record?.financialYearStartDate}
              </span>{' '}
              to{' '}
              <span style={{ color: 'rgba(255, 77, 79, 0.85)' }}>
                {record?.financialYearEndDate}
              </span>{' '}
              ?
            </span>
          </div>
        }
        footer={
          <div className="tw-flex tw-justify-end tw-gap-2">
            <AntButton
              color="yellow"
              type="primary"
              onClick={() => {
                if (userData) {
                  userData.financialId = record?.financialId;
                  userData.financialStartYear = record?.financialYearStartDate;
                  userData.financialEndYear = record?.financialYearEndDate;
                  userData.dateType = record?.dateType;
                  userData.isActive = record?.isActive;
                  userData.showYear = record?.showYear;
                  localStorage.setItem('userData', encryptData(userData));
                }
                if (record?.financialId) {
                  Cookies.set('financialYear', record?.financialId, {
                    expires: 7,
                  });
                }
                if (record?.financialId) {
                  dispatch(addFinancialData({ ...userData, ...record }));
                }
                setConfirmVisible(false);
                setFiscalYearOpen(false);
                confirm({
                  title: 'Fiscal year changed successfully.',
                  content: 'You will be redirected to the dashboard.',
                  icon: (
                    <ExclamationCircleFilled style={{ color: '#eb9e2a' }} />
                  ),
                  onOk: () => {
                    navigate('/dashboard/');
                    window.location.reload();
                  },
                  okCancel: false,
                });
              }}
            >
              Yes, Switch
            </AntButton>

            <AntButton color="red" onClick={() => setConfirmVisible(false)}>
              Cancel
            </AntButton>
          </div>
        }
      />
    </>
  );
};

const columns = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'sn',
    render: (_, __, index) => <p>{index + 1}</p>,
  },
  {
    title: 'Financial Year Start Date',
    dataIndex: 'financialYearStartDate',
    key: 'financialYearStartDate',
  },
  {
    title: 'Financial Year End Date',
    dataIndex: 'financialYearEndDate',
    key: 'financialYearEndDate',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 80,
    align: 'center',
    render: (text) => {
      return text ? (
        <Tag color="green">Active</Tag>
      ) : (
        <Tag color="red">Inactive</Tag>
      );
    },
  },
  {
    title: 'Date Type',
    dataIndex: 'dateType',
    key: 'dateType',
    width: 90,
    align: 'center',
    render: (text) => <div>{text === 'bs' ? 'BS' : 'AD'}</div>,
  },
];
